import dayjs from 'dayjs'

import 'dayjs/locale/id'
import 'dayjs/locale/en'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

dayjs.locale('id')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
